import React from 'react';
import { BiTrash } from "react-icons/bi";
import { Table, Button } from 'react-bootstrap';
import EditableField from './EditableField';
import { useTranslation } from 'react-i18next';

// Define types for props
export interface Item {
  id: string;
  name: string;
  description: string;
  quantity: number;
  price: string;
}

interface InvoiceItemProps {
  items: Item[];
  currency: string;
  onItemizedItemEdit: (evt: React.ChangeEvent<HTMLInputElement>) => void;
  onRowDel: (item: Item) => void;
  onRowAdd: (evt: React.FormEvent) => void;
}

interface ItemRowProps {
  item: Item;
  currency: string;
  onItemizedItemEdit: (evt: React.ChangeEvent<HTMLInputElement>) => void;
  onDelEvent: (item: Item) => void;
}

const InvoiceItem: React.FC<InvoiceItemProps> = ({onItemizedItemEdit, currency, onRowDel, items, onRowAdd}) => {

    const { t } = useTranslation();
  
    // Use arrow function to avoid binding issues
    const itemTable = items.map((item) => (
      <ItemRow
        onItemizedItemEdit={onItemizedItemEdit}
        item={item}
        onDelEvent={onRowDel}
        key={item.id}
        currency={currency}
      />
    ));

    return (
      <div>
        <Table>
          <thead>
            <tr>
              <th>{t('item.item')}</th>
              <th>{t('item.quantity')}</th>
              <th>{t('item.price') + '/' + t('item.rate')}</th>
              <th className="text-center">{t('item.action')}</th>
            </tr>
          </thead>
          <tbody>{itemTable}</tbody>
        </Table>
        <Button className="fw-bold" onClick={onRowAdd}>
          {t('item.addItem')}
        </Button>
      </div>
    );
  
}

const ItemRow: React.FC<ItemRowProps> = ({ item, onDelEvent, onItemizedItemEdit, currency }) => {
  const { t } = useTranslation();

  const onDelEventClick = () => {
    onDelEvent(item);
  };

  return (
    <tr>
      <td style={{ width: '100%', minWidth: '110px'}}>
        <EditableField
          onItemizedItemEdit={onItemizedItemEdit}
          cellData={{
            type: 'text',
            name: 'name',
            placeholder: t('item.name'),
            value: item.name,
            id: item.id.toString(),
          }}
        />
        <EditableField
          onItemizedItemEdit={onItemizedItemEdit}
          cellData={{
            type: 'text',
            name: 'description',
            placeholder: t('item.description'),
            value: item.description,
            id: item.id.toString(),
          }}
        />
      </td>
      <td style={{ minWidth: '70px' }}>
        <EditableField
          onItemizedItemEdit={onItemizedItemEdit}
          cellData={{
            type: 'number',
            name: 'quantity',
            min: 1,
            step: 1,
            value: item.quantity,
            id: item.id,
          }}
        />
      </td>
      <td style={{ minWidth: '130px' }}>
        <EditableField
          onItemizedItemEdit={onItemizedItemEdit}
          cellData={{
            leading: currency,
            type: 'number',
            name: 'price',
            min: 0.01,
            step: 0.01,
            precision: 2,
            textAlign: 'text-end',
            value: item.price,
            id: item.id,
          }}
        />
        {}
      </td>
      <td className="text-center" style={{ minWidth: '50px' }}>
        <BiTrash
          onClick={onDelEventClick}
          style={{ height: '33px', width: '33px', padding: '7.5px' }}
          className="text-white mt-1 btn btn-danger"
          aria-label="Delete item"
        />
      </td>
    </tr>
  );
};

export default InvoiceItem;
